<div class="row">
  <div class="col-12">
    <div class="float-right back-btn" (click)="goToPreviewPage()">
      <button type="button" class="btn btn-primary btn-rounded mb-2 mr-2" style="font-weight: 700">Back</button>
    </div>
  </div>
</div>
